import { FullViewLoadingSpinner } from '@/_elements/Loaders';
import { calendarIntegrationService } from '@/_services/api/calendarIntegration';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import CalendarProviderCard from './CalendarProviderCard';
import { calendarIntegrationUtils } from '../utils/utils';
import { Button } from 'react-bootstrap';
import { CALENDAR_PROVIDERS } from './calendarProviders';

const CalendarConnect = ({ icon, title, description, calendarProvider, fetchAccounts, handleClose = () => {} }) => {
    const [isBusy, setIsBusy] = useState(false);
    const handleConnect = async () => {
        try {
            setIsBusy(true);
            const response = await calendarIntegrationService.authorizeCalendar({ calendarProvider });
            if (response && response.authUrl) {
                poptastic(response.authUrl);
            }
        } catch (error) {
            toast.error(error?.message || 'Failed to get authorization');
        } finally {
            setIsBusy(false);
            fetchAccounts();
            handleClose();
        }
    };
    return (
        <div className="mb-3  border  rounded p-3 d-flex flex-row justify-content-between">
            <div className="d-flex flex-row">
                <div>{icon}</div>
                <div className="d-flex flex-column ml-4">
                    <div>{title}</div>
                    <div className="text-muted">{description}</div>
                </div>
            </div>
            <div>
                <Button variant="primary" onClick={() => handleConnect()} disabled={isBusy}>
                    {isBusy ? 'Connecting...' : 'Connect'}
                </Button>
            </div>
        </div>
    );
};

const poptastic = (url) => {
    var newWindow = window.open(url, 'name', 'height=700,width=1000');
    if (window.focus) {
        newWindow.focus();
    }
};
const PersonalCalendarList = ({ teamOptions, handleClose = () => {} }) => {
    const [calendarAccounts, setCalendarAccounts] = useState([]);
    const [isBusy, setIsBusy] = useState(false);
    const fetchAccounts = async () => {
        try {
            setIsBusy(true);
            const response = await calendarIntegrationService.getExternalCalendarAccounts();
            setCalendarAccounts(response?.results || response?.data || []);
        } catch (error) {
            if (error?.name !== 'AbortError') toast.error(error?.message);
        } finally {
            setIsBusy(false);
        }
    };

    useEffect(() => {
        fetchAccounts();
    }, []);

    const hasGoogleCalendar = calendarAccounts.some((acc) => acc.calendarProvider === 'GOOGLE_CALENDAR');
    const hasOutlookCalendar = calendarAccounts.some((acc) => acc.calendarProvider === 'OUTLOOK_CALENDAR');
    if (isBusy && !hasGoogleCalendar && !hasGoogleCalendar) {
        return <FullViewLoadingSpinner size={'30vh'} />;
    }
    return (
        <div>
            {calendarAccounts.map((account) => (
                <CalendarProviderCard
                    key={account._id}
                    account={{
                        ...account,
                        displayName: calendarIntegrationUtils.formatProviderName(account?.calendarProvider || ''),
                    }}
                    fetchAccounts={fetchAccounts}
                    teamOptions={teamOptions}
                />
            ))}
            {!hasGoogleCalendar && (
                <CalendarConnect
                    icon={CALENDAR_PROVIDERS.GOOGLE_CALENDAR.icon}
                    title="Google Calendar"
                    description="Connect Google Calendar Account"
                    fetchAccounts={fetchAccounts}
                    calendarProvider="GOOGLE_CALENDAR"
                    handleClose={handleClose}
                />
            )}
            {!hasOutlookCalendar && (
                <CalendarConnect
                    icon={CALENDAR_PROVIDERS.OUTLOOK_CALENDAR.icon}
                    title="Outlook Calendar"
                    description="Connect Outlook Calendar Account"
                    calendarProvider="OUTLOOK_CALENDAR"
                    fetchAccounts={fetchAccounts}
                    handleClose={handleClose}
                />
            )}
        </div>
    );
};

export default PersonalCalendarList;
